// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__aNwhl","hand":"Home_hand__HQYY5","wave":"Home_wave__eb3wd","resume":"Home_resume__JzEI9","background-image":"Home_background-image__Tb5Dn"};